import { useAuth } from '@clerk/clerk-react'
import { Navigate } from 'react-router-dom'

import { Hero } from '@/components/sections/Hero'
import { HowItWorks } from '@/components/sections/HowItWorks'
import { LatestDrops } from '@/components/sections/LatestDrops'

export function HomePage() {
  const { isLoaded, isSignedIn } = useAuth()

  if (!isLoaded) {
    return null
  }
  if (isSignedIn) {
    return <Navigate to="/discover" replace />
  }

  return (
    <main
      id="main"
      className="max-w-site px-margin-mobile md:px-margin-desktop mx-auto w-full flex-grow scroll-mt-16 space-y-20 pt-24 pb-24 md:space-y-28 md:pt-28"
    >
      <Hero />
      <HowItWorks />
      <LatestDrops />
    </main>
  )
}
